import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import {
  RECAP_CARD_SPACING_INSET,
  RECAP_CARD_TOKENS,
  NO_RECAP_HEADING,
  RECAP_HEADING,
  RECAP_WRAPPER_SPACING_INSET,
} from "./agenda.constants";

/**
 * Recap panel for a completed agenda item. Mounted in the step's children slot so it sits inside
 * the tracker's track rather than beside it.
 *
 * Every completed item can expand, so recap may be absent — generation can fail or find nothing
 * worth summarizing. That case says so in the heading and drops the body
 */
const AgendaRecapCard = ({ recap }) => (
  // The wrapper's padding replaces the step spacer this card displaces, so an expanded row keeps
  // the same breathing room from the rows above and below as a collapsed one.
  <Box spacingInset={RECAP_WRAPPER_SPACING_INSET} width="100%">
    <Theme tokens={RECAP_CARD_TOKENS}>
      <Box type="outline" spacingInset={RECAP_CARD_SPACING_INSET} width="100%">
        <Column spacing="200">
          <Text type="h50">{recap ? RECAP_HEADING : NO_RECAP_HEADING}</Text>
          {recap && <Text type="b200">{recap}</Text>}
        </Column>
      </Box>
    </Theme>
  </Box>
);

export default AgendaRecapCard;
